import { ApiMethod } from 'services/api/instance';

import { useRestQuery, RestQueryHookOptions } from 'utils/hooks/api/useRestQuery';
import { useRestMutation, UseRestMutationOptions } from 'utils/hooks/api/useRestMutation';

export const GET_TEMPLATE_HISTORY_URL = '/templates/history.json';
export const POST_RESTORE_TEMPLATE_CONTENT_URL = '/templates/updateTemplateContentId';

export const useGetTemplateHistory = (
  searchParamsTemplateId: string,
  options?: RestQueryHookOptions,
) => useRestQuery(GET_TEMPLATE_HISTORY_URL, { templateId: searchParamsTemplateId }, options);

export const usePostRestoreTemplateContent = (options?: UseRestMutationOptions) =>
  useRestMutation(POST_RESTORE_TEMPLATE_CONTENT_URL, ApiMethod.post, options);
